import React from 'react';

// Shared "no photo/video" placeholder - the real nemonto brand mark
// (public/image/nemontoicon.png). The source PNG has a lot of empty
// padding around the mark itself, so it's rendered oversized inside a
// clipped, centered box rather than at 1:1 - otherwise the bowl/spoon
// icon would look tiny at the small sizes this is used at (~32-72px).
const MediaPlaceholderIcon = ({ size = 48, className }) => (
  <div
    className={className}
    style={{
      width: size,
      height: size,
      overflow: 'hidden',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
    }}
  >
    <img
      src="/image/nemontoicon.png"
      alt=""
      style={{ width: size * 2.4, height: size * 2.4, objectFit: 'contain' }}
    />
  </div>
);

export default MediaPlaceholderIcon;
